// SparkX AI License Config — AllStarGadget
// এই ফাইলটি সরাসরি .gitignore তে যোগ করুন, public repo তে commit করবেন না।

export const LICENSE_CONFIG = {
  apiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/verify-license',
  renewalApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-renewal-payment',
  packageStatusApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/package-status',
  requestPackagePaymentApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-payment',
  packagesApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/packages',
  requestPackageUpgradeApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-upgrade',
  apiKey: 'lic_live_060edcd8a605081dd0d5ec1f68a4928b0cf226525c197b77',
  domain: 'alifbuy.com',
  supportWhatsApp: '01516585709',
};